import i18n from 'i18n'
import * as React from "react"
import { SelectAjaxSeeker } from "ui-seeker/core"
import { FORMAT_DATE_BACK, formatDate } from 'ui-seeker/utils'

import { SelectLoading } from "app/components/loading"
import { formatSiteWithLogo } from "app/utils"
import { PACKAGES_URL } from 'app/@common/constants'
import { getAppUserData } from "app/@utils";


export default function SelectOtas({ section, ...props }) {

    const { role } = getAppUserData()

    if (role !== 'admin' && section !== 'packages') return <SelectLoading />
    if (section === 'packages' && ((Array.isArray(props.selectedRoute) && !!props.selectedRoute) || !props.selectedRoute)) return <SelectLoading />

    const myProps = {
        urlAjax: PACKAGES_URL.SITES,
        placeholder: i18n.t('common:filters.allSites'),
        icon: { icon: 'browser' },
        formatOptionLabel: ({ label }) => formatSiteWithLogo({ siteName: label.toLowerCase() }),
        extraParams: {
            ...props.refresh && { refresh_cache: props.refresh },
            ...props.selectedRoute?.length && { routes: props.selectedRoute },
            ...props.id_report_execution && { id_report_execution: props.id_report_execution },
            ...'id_main_hotel' in props && { id_main_hotel: props.id_main_hotel },
            dateRange: props.date,
            ...props.date === 'custom' && { 
                startDate: formatDate(props.customDates[0], { format: FORMAT_DATE_BACK }),
                endDate: formatDate(props.customDates[1], { format: FORMAT_DATE_BACK })
            }
        },
        isClearable: false,
        isMulti: true,
        limitedChips: true,
        ...props
    }
    
    return <SelectAjaxSeeker {...myProps} />
}